export const KOPER = [
  {
    vraag: 'Is de invoerkabel in goede conditie?',
    answerq: true,
    ja: 'Begin met je kopermeting',
    nee: 'Strip de invoerkabel opnieuw aan en begin met je kopermeting',
    handleiding: 'invoerkabels',
    id: 1,
  },

  {
    vraag: 'Was de kopermeting volgens norm?',
    subHead: `<3V <3% >3MOhm`,
    answerq: true,
    ja: 'Sla je meting op in je voortgang en controleer het isra punt.',
    nee: 'Meet indien beschikbaar het andere aderpaar',
    handleiding: 'meetwaarden',
    id: 2,
  },
  {
    vraag: 'Is de kopermeting van het andere aderpaar wel in orde?',
    answerq: true,
    ja: 'Zet deze meting in je voortgang en hang je pieper op en ga naar de KVD/ HVD. Verbind deze door naar de juiste poort. Vergeet niet de nieuwe KANVAS gegevens door te geven aan MI. Controleer het isra punt.',
    nee: 'Bel MI voor OG aansturing.',
    tel: '0800 022 63 89',
    id: 3,
  },
  {
    vraag: 'Is het isra punt volgens norm?',
    answerq: true,
    ja: 'Controleer of je sync hebt op je lijn.',
    nee: 'Vervang het isra punt volgens norm en controleer of je sync hebt op je lijn.',
    handleidingDisable: 'isra',
    id: 4,
  },
  {
    vraag: 'Komt je lijn in Sync?',
    answerq: true,
    ja: 'Controleer Service ID in monteurs tool',
    nee: 'start Selt meting en controleer gegevens',
    handleiding: 'sync',
    id: 5,
  },
  {
    vraag: 'Komt het service ID online in de monteurs tool?',
    answerq: true,
    ja: 'Begin met je installatie of hang test label kaartje aan je verbinding en maak een foto als bijlage.',
    nee: 'Hang je pieper op en controleer in de KVD of HVD op kruising',
    handleidingDisable: 'monteurstool',
    id: 6,
  },
  {
    vraag: 'Zie je de modem koppeling in je monteurstool staan?',
    answerq: true,
    ja: 'Meld je opdracht af.',
    nee: 'Wacht een aantal minuten, voer anders een modem reset uit.',
    id: 7,
  },
];
